import { render, staticRenderFns } from "./yszc.vue?vue&type=template&id=c41a0f0e"
import script from "./yszc.vue?vue&type=script&lang=js"
export * from "./yszc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports